export { Text } from './Text';
export { useOverflowStrategy } from './useOverflowStrategy';
export {
  DefaultTextPropsProvider,
  useDefaultTextProps,
} from './defaultTextProps';

export type { TextProps } from './Text';
export type { OverflowStrategyType } from './useOverflowStrategy';
